<div class='info-list-2'>
  <info-list-item label='Top Device' [lock]="isFreemium"
    labelTooltip='The platform most commonly trafficked in programmatic advertising'
    (labelInteract)='goToSection("#inventory-devices-cont")'
    [value]='data?.inventoryDistribution?.devices[0]?.deviceMarketingName'></info-list-item>

  <info-list-item label='Display Top Ad Size' [lock]="isFreemium"
    labelTooltip='The display ad size most commonly trafficked in programmatic advertising'
    (labelInteract)='goToSection("#inventory-ad-sizes-cont")'
    [value]='data?.advertisingCapabilities?.displayTopAdSizes[0]'></info-list-item>

  <info-list-item label='Video Top Ad Size' [lock]="isFreemium"
    labelTooltip='The video ad size most commonly trafficked in programmatic advertising'
    [value]='data?.advertisingCapabilities?.videoTopAdSizes[0]'></info-list-item>

  <info-list-item label='Video Contribution' [lock]="isFreemium"
    labelTooltip='The percentage of video ads trafficked on the app'
    value='{{data?.advertisingCapabilities?.videoImpressionRatio | perc: "1.2-2"}}'></info-list-item>

  <info-list-item label='Display Contribution' [lock]="isFreemium"
    labelTooltip='The percentage of display ads trafficked on the app'
    value='{{data?.advertisingCapabilities?.displayImpressionRatio | perc: "1.2-2"}}'></info-list-item>

  <info-list-item label='HyperLocation Availability' [lock]="isFreemium"
    labelTooltip="The percentage of advertising transactions containing the user's latitude and longitude"
    value='{{data?.advertisingCapabilities?.hyperLocationImpressionsRatio | perc: "1.2-2"}}'></info-list-item>

  <info-list-item label='MRAID Version' [lock]="isFreemium"
    labelTooltip="The most recent version of MRAID for which the app is compliant."
    value='{{data?.advertisingCapabilities?.mraidVersion}}'></info-list-item>

  <info-list-item label='Ads Detected?' [lock]="isFreemium"
    labelTooltip="Non ad-supported apps may be at risk of spoofing."
    valueIcon='/assets/images/icon-indicator-{{data?.advertisingCapabilities?.hasAdServed | yesno}}-2.svg'
    value='{{data?.advertisingCapabilities?.hasAdServed | yesno:"capitalize"}}'></info-list-item>
</div>